import React, { Fragment , useEffect,useState } from 'react'

import './litigations.css'
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Axios from 'axios'
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import CancelIcon from '@mui/icons-material/Cancel';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
let user=JSON.parse(localStorage.getItem('user-info'))

const columns = [
  { id: 'Nom', label: 'Direction', minWidth: 180 },
  { id: 'city', label: 'city', minWidth: 170 },
  { id: 'Raison', label: 'Raison', minWidth: 250, align: 'left', },
  { id: 'Show', label: 'Afficher', minWidth: 0, align: 'left', },
  { id: 'Rate', label: 'Évaluer', minWidth:  0, align: 'left' },
];

function createData(fullName, city, Raison,Show,Rate) {
  return { fullName, city, Raison,Show,Rate};
}

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
});



function Litigations() {

  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [Data, setData] = React.useState([]);
  const handleCloseRate = () => { setOpenRate(false); };
  const handleClose = () => { setOpen(false); };
  const [open, setOpen] = React.useState(false);
  const [ReclamationTxt, setReclamationTxt] = React.useState('');
  const [OpenRate,setOpenRate]=useState(false);

  const rows = [
    Data.map((o, i) => createData(Data[i].fullName,Data[i].city+" / "+Data[i].country, Data[i].raison,
    <Button variant='contained' onClick={()=>{Reclamation(i)}}>Afficher</Button>,
    <Box component="fieldset" ><Rating name="read-only" value={Data[i].rate} readOnly /></Box>))
  ]

  const Reclamation = (i) => {
    setOpenRate(true);
    setReclamationTxt(Data[i].reclamation);
    //console.log(Data[i].reclamation);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(()=>{
      Axios.get("http://127.0.0.1:8000/api/servicePrincipale/litiges/"+user.id)
        .then((reponse)=> {
          setData(reponse.data);
          //console.log(reponse.data);
        })
  },[]);

  return (
    <div className='litigations_container'>
      <div className='litigations_container_header'>
            <div><label>Mes appels</label></div>
      </div>
          <Paper className='litigations_table'>
            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }} >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows[0].slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={row.city}>
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            </Paper>

            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />

          <Dialog fullWidth={true} maxWidth={'md'} open={OpenRate} onClose={handleCloseRate} aria-labelledby="form-dialog-title" >
            <DialogTitle id="form-dialog-title">Noter Appel d'Offre </DialogTitle>
            <DialogContent className="rateEdit" >
              {ReclamationTxt}
            </DialogContent>
            <DialogActions>
              <Button variant="contained" style={{background:'red', color:'white'}} className={classes.button} startIcon={<CancelIcon />} onClick={handleClose} >
                cancel
              </Button>
            </DialogActions>
          </Dialog>
    </div>    
  );
}

export default Litigations;
